import {FC, useEffect} from "react";
import {Grid, TextField, Tooltip} from "@material-ui/core";
import * as React from "react";
import {AkamaiTokenData} from "./types/akamaiTokenData";


interface Props {
    limelight_token: AkamaiTokenData;
    limelight_key : string ;
    expire : string;
}

const VerizonToken : FC<Props> = ({limelight_token , limelight_key , expire}) => {

    const [key , setKey] = React.useState<any>('');
    const [limelight_expire , setExpire] = React.useState<any>('');

    useEffect( ()=> {
        limelight_token(JSON.stringify({"secret" : key , "expire" : limelight_expire}))
    },[key,limelight_expire])

    useEffect(() => {
        if (limelight_key && expire){
            setKey(limelight_key)
            setExpire(expire)
        }

    }, [limelight_key, expire])

    return(
        <>
            <Grid item md={3}>
                <Tooltip title="The key needed to generate the limelight token for stream protection" placement='top-end' aria-multiline>
                    <TextField
                        placeholder="Limelight Key"
                        variant="outlined"
                        name="key"
                        value={limelight_key}
                        fullWidth
                        onChange={e => {setKey(e.target.value)}}
                    />
                </Tooltip>
            </Grid>
            <Grid item md={3}>
                <Tooltip title="Time in minutes of validity" placement='top-end' aria-multiline>
                    <TextField
                        placeholder="Expire"
                        variant="outlined"
                        name='expire'
                        value={expire}
                        fullWidth
                        onChange={e => {setExpire(e.target.value)}}
                    />
                </Tooltip>
            </Grid>
        </>

    )
}




export default VerizonToken;